document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-flowik-showroom]');
  if (!root) return;

  var imageEl = root.querySelector('[data-showroom-image]');
  var captionEl = root.querySelector('[data-showroom-caption]');
  var groupBar = document.querySelector('[data-showroom-groups]');
  var decorsLabel = root.querySelector('[data-showroom-decors-label]');
  var images = window.flowikShowroomImages || {};
  var groupLabels = window.flowikShowroomGroupLabels || {};
  var decors = window.flowikShowroomDecors || {};

  var state = { group: 's1', room: 'obyvak' };

  function render() {
    var src = (images[state.group] || {})[state.room];
    if (src && imageEl) imageEl.src = src;

    var decorName = (decors[state.group] || {})[state.room];
    if (captionEl) {
      captionEl.textContent = decorName || '';
    }

    root.querySelectorAll('[data-showroom-decors] [data-group]').forEach(function (chip) {
      chip.hidden = chip.dataset.group !== state.group;
    });

    if (decorsLabel) {
      decorsLabel.textContent = 'Dekory ve skupině ' + (groupLabels[state.group] || state.group);
    }
  }

  if (groupBar) {
    groupBar.querySelectorAll('[data-group]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        groupBar.querySelectorAll('[data-group]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.group = btn.dataset.group;
        render();
      });
    });
  }

  root.querySelectorAll('[data-showroom-rooms] [data-room]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('[data-showroom-rooms] [data-room]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      state.room = btn.dataset.room;
      render();
    });
  });

  render();
});
